/**
 * @generated SignedSource<<c3ae618ba2779e24248208ad6766446c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type HomePanelGroupType = "MEETINGS" | "ONE_ON_ONE" | "OTHER_STREAMS" | "REGULAR" | "TEAMS";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type HomePanelMoveItemMutation$variables = {
  groupId: string;
  objectId: string;
  position: number;
};
export type HomePanelMoveItemMutation$data = {
  readonly addOrMoveToGroup: {
    readonly movedObject: {
      readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroupsMenu_object">;
    };
    readonly viewer: {
      readonly homePanelGroups: ReadonlyArray<{
        readonly id: string;
        readonly items: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id?: string;
              readonly " $fragmentSpreads": FragmentRefs<"StreamLink_stream" | "TagLink_tag">;
            } | null;
          } | null>;
        };
        readonly " $fragmentSpreads": FragmentRefs<"HomePanelGroup_group">;
      } | null> | null;
    };
  } | null;
};
export type HomePanelMoveItemMutation$rawResponse = {
  readonly addOrMoveToGroup: {
    readonly movedObject: {
      readonly __typename: "NoteStream";
      readonly __isHomePanelObjectInterface: "NoteStream";
      readonly homePanelGroup: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly type: NoteStreamType;
    } | {
      readonly __typename: string;
      readonly __isHomePanelObjectInterface: string;
      readonly homePanelGroup: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
    };
    readonly viewer: {
      readonly homePanelGroups: ReadonlyArray<{
        readonly emojiName: string | null;
        readonly id: string;
        readonly items: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: "NoteStream";
              readonly __isHomePanelObjectInterface: "NoteStream";
              readonly __isNode: "NoteStream";
              readonly archived: boolean | null;
              readonly displayName: string;
              readonly hasExternalUsers: boolean;
              readonly homePanelGroup: {
                readonly id: string;
                readonly name?: string;
              } | null;
              readonly id: string;
              readonly isExternal: boolean;
              readonly latestNote: {
                readonly event: {
                  readonly calendar: {
                    readonly id: string;
                  };
                  readonly conferenceCalls: ReadonlyArray<{
                    readonly provider: ConferenceCallProvider;
                    readonly url: string;
                  }>;
                  readonly guid: string;
                  readonly id: string;
                  readonly isAllDay: boolean;
                  readonly start: string | null;
                  readonly status: StatusChoices;
                  readonly timeBlockType: string | null;
                  readonly willBeRecorded: WillBeRecordedType;
                } | null;
                readonly eventEnd: string | null;
                readonly eventStart: string | null;
                readonly finished: boolean;
                readonly id: string;
              } | null;
              readonly latestNoteEditedAt: string | null;
              readonly linkedEvent: {
                readonly finalOccurrence: string | null;
                readonly guid: string;
                readonly id: string;
                readonly nextOccurrence: {
                  readonly calendar: {
                    readonly id: string;
                  };
                  readonly conferenceCalls: ReadonlyArray<{
                    readonly provider: ConferenceCallProvider;
                    readonly url: string;
                  }>;
                  readonly end: string | null;
                  readonly guid: string;
                  readonly id: string;
                  readonly isAllDay: boolean;
                  readonly start: string | null;
                  readonly status: StatusChoices;
                  readonly timeBlockType: string | null;
                  readonly willBeRecorded: WillBeRecordedType;
                } | null;
              } | null;
              readonly otherUser: {
                readonly activeRecurring1on1Event: {
                  readonly id: string;
                } | null;
                readonly email: string;
                readonly fullName: string;
                readonly hasReceivedInvites: boolean;
                readonly id: string;
                readonly image: string;
                readonly isActive: boolean;
                readonly isConfigured: boolean;
                readonly isGuest: boolean;
                readonly isTopUser: boolean;
                readonly relationshipToViewer: AncestryRelationship | null;
              } | null;
              readonly publicLink: {
                readonly enabled: boolean;
                readonly id: string;
              } | null;
              readonly starred: boolean;
              readonly type: NoteStreamType;
              readonly url: string | null;
              readonly userCount: number;
              readonly viewerLastSeenAt: string | null;
            } | {
              readonly __typename: "Tag";
              readonly __isHomePanelObjectInterface: "Tag";
              readonly __isNode: "Tag";
              readonly color: Colors;
              readonly homePanelGroup: {
                readonly id: string;
                readonly name?: string;
              } | null;
              readonly id: string;
              readonly label: string;
            } | {
              readonly __typename: "User";
              readonly __isNode: "User";
              readonly activeRecurring1on1Event: {
                readonly id: string;
              } | null;
              readonly email: string;
              readonly fullName: string;
              readonly hasReceivedInvites: boolean;
              readonly id: string;
              readonly image: string;
              readonly isActive: boolean;
              readonly isConfigured: boolean;
              readonly isGuest: boolean;
              readonly isTopUser: boolean;
              readonly relationshipToViewer: AncestryRelationship | null;
            } | {
              readonly __typename: string;
              readonly __isNode: string;
              readonly id: string;
            } | null;
          } | null>;
        };
        readonly name: string;
        readonly type: HomePanelGroupType;
      } | null> | null;
      readonly id: string;
    };
  } | null;
};
export type HomePanelMoveItemMutation = {
  rawResponse: HomePanelMoveItemMutation$rawResponse;
  response: HomePanelMoveItemMutation$data;
  variables: HomePanelMoveItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "objectId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "position"
},
v3 = [
  {
    "kind": "Variable",
    "name": "groupId",
    "variableName": "groupId"
  },
  {
    "kind": "Variable",
    "name": "objectId",
    "variableName": "objectId"
  },
  {
    "kind": "Variable",
    "name": "position",
    "variableName": "position"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isActive",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isConfigured",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasReceivedInvites",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "relationshipToViewer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGuest",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isTopUser",
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "onlyReportManager",
        "value": true
      }
    ],
    "concreteType": "Event",
    "kind": "LinkedField",
    "name": "activeRecurring1on1Event",
    "plural": false,
    "selections": (v5/*: any*/),
    "storageKey": "activeRecurring1on1Event(onlyReportManager:true)"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "HomePanelGroup",
  "kind": "LinkedField",
  "name": "homePanelGroup",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeBlockType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "ConferenceCall",
  "kind": "LinkedField",
  "name": "conferenceCalls",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Calendar",
  "kind": "LinkedField",
  "name": "calendar",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePanelGroup",
      "kind": "LinkedField",
      "name": "homePanelGroup",
      "plural": false,
      "selections": [
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "HomePanelObjectInterface",
  "abstractKey": "__isHomePanelObjectInterface"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePanelMoveItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AddOrMoveToGroup",
        "kind": "LinkedField",
        "name": "addOrMoveToGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelGroup",
                "kind": "LinkedField",
                "name": "homePanelGroups",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "HomePanelGroup_group"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelObjectsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HomePanelObjectsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "StreamLink_stream"
                                  }
                                ],
                                "type": "NoteStream",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TagLink_tag"
                                  }
                                ],
                                "type": "Tag",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "movedObject",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HomePanelGroupsMenu_object"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomePanelMoveItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "AddOrMoveToGroup",
        "kind": "LinkedField",
        "name": "addOrMoveToGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelGroup",
                "kind": "LinkedField",
                "name": "homePanelGroups",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emojiName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HomePanelObjectsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HomePanelObjectsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v10/*: any*/),
                                "type": "User",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "userCount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewerLastSeenAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestNoteEditedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isExternal",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasExternalUsers",
                                    "storageKey": null
                                  },
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "otherUser",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "linkedEvent",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Event",
                                        "kind": "LinkedField",
                                        "name": "nextOccurrence",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "end",
                                            "storageKey": null
                                          },
                                          (v4/*: any*/),
                                          (v13/*: any*/),
                                          (v15/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "finalOccurrence",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Note",
                                    "kind": "LinkedField",
                                    "name": "latestNote",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "eventStart",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "eventEnd",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "finished",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Event",
                                        "kind": "LinkedField",
                                        "name": "event",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v13/*: any*/),
                                          (v15/*: any*/),
                                          (v14/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NoteStreamPublicLink",
                                    "kind": "LinkedField",
                                    "name": "publicLink",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "enabled",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "archived",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "starred",
                                    "storageKey": null
                                  },
                                  (v21/*: any*/)
                                ],
                                "type": "NoteStream",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "color",
                                    "storageKey": null
                                  },
                                  (v12/*: any*/),
                                  (v21/*: any*/)
                                ],
                                "type": "Tag",
                                "abstractKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "movedObject",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHomePanelObjectInterface"
              },
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "NoteStream",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HomePanelGroup",
                "kind": "LinkedField",
                "name": "homePanelGroup",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6fd7d97da844ef4a045780a33147c487",
    "id": null,
    "metadata": {},
    "name": "HomePanelMoveItemMutation",
    "operationKind": "mutation",
    "text": "mutation HomePanelMoveItemMutation(\n  $objectId: ID!\n  $groupId: ID!\n  $position: Int!\n) {\n  addOrMoveToGroup(objectId: $objectId, groupId: $groupId, position: $position) {\n    viewer {\n      homePanelGroups {\n        id\n        ...HomePanelGroup_group\n        items {\n          edges {\n            node {\n              __typename\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on NoteStream {\n                ...StreamLink_stream\n              }\n              ... on Tag {\n                ...TagLink_tag\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    movedObject {\n      __typename\n      ...HomePanelGroupsMenu_object\n      id\n    }\n  }\n}\n\nfragment GroupsMenu_stream on NoteStream {\n  ...HomePanelGroupsMenu_object\n  id\n  homePanelGroup {\n    id\n  }\n}\n\nfragment HomePanelGroup_group on HomePanelGroup {\n  id\n  type\n  name\n  emojiName\n  items {\n    edges {\n      node {\n        __typename\n        ... on User {\n          id\n          ...OneOnOneLink_user\n        }\n        ... on NoteStream {\n          ...StreamLink_stream\n          id\n          archived\n          starred\n          viewerLastSeenAt\n          latestNoteEditedAt\n        }\n        ... on Tag {\n          __typename\n          id\n          label\n          color\n          ...TagLink_tag\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment HomePanelGroupsMenu_object on HomePanelObjectInterface {\n  __isHomePanelObjectInterface: __typename\n  id\n  __typename\n  ... on NoteStream {\n    type\n  }\n  homePanelGroup {\n    id\n    name\n  }\n}\n\nfragment OneOnOneLink_user on User {\n  id\n  fullName\n  image\n  isActive\n  isConfigured\n  email\n  hasReceivedInvites\n  relationshipToViewer\n  isGuest\n  isTopUser\n  activeRecurring1on1Event(onlyReportManager: true) {\n    id\n  }\n}\n\nfragment RecordIcon_event on Event {\n  id\n  guid\n  willBeRecorded\n  start\n  status\n  isAllDay\n  timeBlockType\n  conferenceCalls {\n    provider\n    url\n  }\n  calendar {\n    id\n  }\n}\n\nfragment StreamLink_stream on NoteStream {\n  id\n  type\n  url\n  displayName\n  userCount\n  viewerLastSeenAt\n  latestNoteEditedAt\n  isExternal\n  hasExternalUsers\n  ...GroupsMenu_stream\n  otherUser {\n    ...OneOnOneLink_user\n    id\n  }\n  linkedEvent {\n    id\n    guid\n    nextOccurrence {\n      start\n      end\n      ...RecordIcon_event\n      id\n    }\n    finalOccurrence\n  }\n  latestNote {\n    id\n    eventStart\n    eventEnd\n    finished\n    event {\n      id\n      guid\n      ...RecordIcon_event\n    }\n  }\n  publicLink {\n    enabled\n    id\n  }\n}\n\nfragment TagLink_tag on Tag {\n  id\n  label\n  color\n  homePanelGroup {\n    id\n  }\n  ...HomePanelGroupsMenu_object\n}\n"
  }
};
})();

(node as any).hash = "078d677be809d4aeaab063036e7230c5";

export default node;
